import { AppEvent } from "@faire/app-events/AppEvents";
import { IProductItem } from "@faire/deprecated-retailer-visitor-shared/lib/cartTools";
import { IBrand } from "@faire/web-api--source/indigofair/data/IBrand";
import { IBrandLead } from "@faire/web-api--source/indigofair/data/IBrandLead";
import { IFlashSale } from "@faire/web-api--source/indigofair/data/IFlashSale";
import { IMembership } from "@faire/web-api--source/indigofair/data/IMembership";
import { IOrder } from "@faire/web-api--source/indigofair/data/IOrder";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
import { IUser } from "@faire/web-api--source/indigofair/data/IUser";

export interface IUserAndRetailer {
  user: IUser;
  retailer: IRetailer;
}

export namespace IUserAndRetailer {
  export const build = (
    partial?: Partial<IUserAndRetailer> | undefined
  ): IUserAndRetailer => ({
    user: IUser.build(partial?.user),
    retailer: IRetailer.build(partial?.retailer),
  });
}

export interface IRetailerPurchaseEvent {
  givenProductItems: IProductItem[];
  retailer?: IRetailer;
  order: IOrder;
  brands: Partial<Record<string, IBrand>>;
}

interface IInitiateCheckoutAllCarts {
  cartValue: number;
}

interface IInitiateCheckoutFlashSale {
  cartValue: number;
}

export interface IAddCollectionToCartEvent {
  collectionToken: string;
  isQuickAdd: boolean;
}

export interface IBrandBlogContentSubmission {
  stockists?: number;
}

export interface IPersonalInfoSubmission {
  country: string;
  is_sub_user: boolean;
}

export interface IStoreDetailsSubmission {
  store_type: string;
  years_in_business: string;
  annual_sales: string;
}

export interface IDescribeStoreSubmission {
  store_description: string;
}

export const SignUp = new AppEvent<IUserAndRetailer>("RETAILER_SIGN_UP_EVENT");

export const SignUpPersonalInfoNextPressed =
  new AppEvent<IPersonalInfoSubmission>("PERSONAL_INFO_NEXT_PRESSED");

export const SignUpStoreDetailNextPressed =
  new AppEvent<IStoreDetailsSubmission>("STORE_DETAIL_NEXT_PRESSED");

export const SignUpDescribeStoreNextPressed =
  new AppEvent<IDescribeStoreSubmission>("DESCRIBE_STORE_NEXT_PRESSED");

export const OrderSubmitted = new AppEvent<IRetailerPurchaseEvent>(
  "RETAILER_PURCHASE_EVENT"
);

export const OrderCanceled = new AppEvent<void>("RETAILER_CANCEL_ORDER_EVENT");

export const AddAddress = new AppEvent<void>("RETAILER_ADD_ADDRESS");
export const ChangeShippingAddress = new AppEvent<void>(
  "RETAILER_CHANGE_SHIPPING_ADDRESS"
);

export const AddCollectionToCart = new AppEvent<IAddCollectionToCartEvent>(
  "RETAILER_ADD_COLLECTION_TO_CART"
);

export const InitiateCheckoutAllCarts = new AppEvent<IInitiateCheckoutAllCarts>(
  "INITIATE_CHECKOUT_ALL_CARTS"
);

export const InitiateCheckoutFlashSale =
  new AppEvent<IInitiateCheckoutFlashSale>("INITIATE_CHECKOUT_FLASH_SALE");

export const FlashSaleOrderSubmitted = new AppEvent<IFlashSale>(
  "FLASH_SALE_ORDER_SUBMITTED"
);

export const ViewProduct = new AppEvent<IProduct>("VIEW_PRODUCT");

export const ViewBrand = new AppEvent<Pick<IBrand, "token" | "is_internal">>(
  "VIEW_BRAND"
);

export const InsiderMembershipPurchase = new AppEvent<IMembership>(
  "INSIDER_MEMBERSHIP_PURCHASE"
);

export const SearchForProduct = new AppEvent<string>("SEARCH_FOR_PRODUCT");

export const PaidInvoicesSuccess = new AppEvent<void>("PAID_INVOICES_SUCCESS");

export const LimitIncreaseApplicationSubmitted = new AppEvent<void>(
  "LIMIT_INCREASE_APPLICATION_SUBMITTED"
);

export const MakerSubmitApplication = new AppEvent<IBrandLead>(
  "MAKER_APPLY_EVENT"
);
export const MakerAdPageApply = new AppEvent<IBrandLead>("AD_PAGE_APPLY");

export const PageInitialized = new AppEvent<void>("PAGE_INIT");

export const RefusedRedirectToExternalUrl = new AppEvent<string>(
  "REFUSED_REDIRECT_TO_EXTERNAL_URL"
);

export const BrandBlogContentFormSubmission =
  new AppEvent<IBrandBlogContentSubmission>(
    "BRAND_BLOG_CONTENT_FORM_SUBMISSION"
  );

export const InsiderMembershipMutated = new AppEvent<void>(
  "INSIDER_MEMBERSHIP_MUTATED"
);

export const OpenWithFairePageView = new AppEvent<void>(
  "OPEN_WITH_FAIRE_PAGE_VIEW"
);

export const OpenWithFairePageYesFundingSelected = new AppEvent<void>(
  "OPEN_WITH_FAIRE_PAGE_YES_FUNDING_SELECTED"
);

export const OpenWithFaireSignUpApplicationView = new AppEvent<void>(
  "OPEN_WITH_FAIRE_SIGN_UP_APPLICATION_VIEW"
);

export const OpenWithFaireStoreInfoSectionNextPressed = new AppEvent<void>(
  "OPEN_WITH_FAIRE_STORE_INFO_SECTION_NEXT_PRESSED"
);

export const OpenWithFaireOwnershipSectionNextPressed = new AppEvent<void>(
  "OPEN_WITH_FAIRE_OWNERSHIP_SECTION_NEXT_PRESSED"
);

export const OpenWithFaireFinancialSectionNextPressed = new AppEvent<void>(
  "OPEN_WITH_FAIRE_FINANCIAL_SECTION_NEXT_PRESSED"
);

export const OpenWithFaireAdditionalSectionNextPressed = new AppEvent<void>(
  "OPEN_WITH_FAIRE_ADDITIONAL_SECTION_NEXT_PRESSED"
);
